import {
  IonCol,
  IonGrid,
  IonRow,
  IonLoading,
} from "@ionic/react";
import { useRef, useState } from "react";
import "react-quill/dist/quill.snow.css";
import { useDispatch, useSelector } from "react-redux";
import { setTemplateText } from "../../../store/templateDetail";
import { selectQuestionList } from "../../../store/templateDetail/selectors/selectQuestionList";
import { selectSegmentSelected } from "../../../store/templateDetail/selectors/selectSegmentSelected";
import { selectTemplateDetail } from "../../../store/templateDetail/selectors/selectTemplateDetail";
import { miDtData } from "../../../utils/miDtData";
import "../../../utils/ql-editor.css";
import JoditEditor from "jodit-react";
import { Jodit } from "jodit"
import api from "../../../utils/api";
import "../../../theme/jodit.css";

export const TemplatePreviewContainer = () => {
  const dispatch = useDispatch();
  const [generatePDF, setGeneratePDF] = useState<boolean>(false);
  const { richText } = useSelector(selectTemplateDetail);
  const questionList = useSelector(selectQuestionList);
  const segmentSelected = useSelector(selectSegmentSelected);

  const editor = useRef(null);
  let jodit: Jodit;

  const handlePageBreak = (editor: Jodit) => {
    editor.selection.insertHTML(`<div class="page-break" style="break-after: page; width: 100%; background-color: #eee; color: #555; font-weight: 400;"><--- Salto de página ---></div>`)
  }

  const handleViewPDF = async (value: string) => {
    setGeneratePDF(true);
    try {
      // Genera PDF
      const token = localStorage.getItem("token");
      const headers = new Headers();
      headers.append("Authorization", `Bearer ${token}`);
      headers.append("Content-Type", "application/json");

      
      const responseGenPDF = await fetch(`${api.baseURL}archive/generate-pdf`, {
        method: 'POST',
        body: JSON.stringify({ "text": value, "title": "Vista-Previa" }),
        headers: headers,
      });
      const dataGenPDF = await responseGenPDF.json();

      // Obtiene PDF
      const responseGetPDF = await fetch(`${api.baseURL}archive/${dataGenPDF.id}`, {
        method: 'GET',
        headers: headers,
      });
      const dataGetPDF = await responseGetPDF.blob();
      const file = new Blob([dataGetPDF], { type: 'application/pdf' });
      const fileURL = URL.createObjectURL(file);

      setGeneratePDF(false);
      // Abre PDF en nueva pestaña
      window.open(fileURL, "_BLANK");

    } catch (error) {
      setGeneratePDF(false);
      console.log(error);
    }
  }

  // Crea botones para incluirlos en Rich Text Editor
  const buttons = questionList?.map(({ label, type }, index) => {
    if (type === "text") {
      return {
        name: index.toString(),
        text: label,
        exec: function (editor: any) {
          editor.s.insertHTML(`<code class="ql-label" style="background-color: lightblue;" contenteditable="false">${label}</code>`);
        }
      }
    } else {
      // Si es tipo usuario genera botones con listas desplegables
      const array: any = [] // Array para incluir lista desplegable
      Object.entries(miDtData).map(([key, value]) => {
        return array[key] = value
      });
      return {
        name: index.toString(),
        text: label,
        list: { ...array },
        childTemplate: (editor: any, key: string, value: string) => {
          return `<span>${value}</span>`;
        },
        exec: function (editor: any, t: any, { control }: { control: any }) {
          control.args && editor.selection.insertHTML(`<code class="ql-label" style="background-color: lightblue;" contenteditable="false">${label}#${control.args[0]}</code>`);
        }

      }
    }
  }
  );

  const generatePageBreak = {
    name: "Genera Page Break",
    text: "Salto de página",
    exec: function (editor: Jodit) {
      handlePageBreak(editor);
    }
  }
  buttons.push(generatePageBreak);

  const generatePdfButton = {
    name: "Genera vista en PDF",
    text: "Ver PDF",
    exec: function (editor: Jodit) {
      handleViewPDF(editor.value);
    }
  }
  buttons.push(generatePdfButton);

  // Configuraciones para el Rich Text Editor
  const config : any =
  {
    readonly: false,
    "defaultActionOnPaste": "insert_clear_html",
    // uploader: { insertImageAsBase64URI: true },
    placeholder: "Escriba el contenido del documento aquí",
    language: 'es',
    height: '80vh',
    events: {
      // Importante para obtener la instancia de Jodit
      afterInit: (instance: any) => {
        jodit = instance;
      },
    },
    "buttons": "bold,italic,underline,strikethrough,align,eraser,ul,ol,font,fontsize,paragraph,lineHeight,superscript,subscript,image,link,spellcheck,cut,copy,paste,selectall,table,print",
    extraButtons: buttons,
  };

  // Guarda texto cada vez que se pierde el foco del editor
  const onBlur = (value: string) => {
    dispatch(setTemplateText(value));
  }

  return (
    <>
      {segmentSelected === "preview" && (
        <IonGrid>
          <IonRow>
            <IonCol style={{backgroundColor: "#fff"}}>
              <JoditEditor
                ref={editor}
                value={richText!}
                config={config}
                onBlur={(newContent) => onBlur(newContent)}
              />
            </IonCol>
          </IonRow>
          <IonLoading isOpen={generatePDF === true} message={"Creando PDF..."} />
        </IonGrid>
      )
      }
    </>
  );
};
